import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const organizationSettings: AppRouteModule = {
  path: '/organization/settings',
  name: 'OrganizationSettings',
  component: LAYOUT,
  meta: {
    title: '合作方设置',
    hideMenu: true,
  },
  children: [
    {
      path: '',
      name: 'OrganizationSettingsPage',
      component: () => import('/@/views/organization/settings/index.vue'),
      meta: {
        title: '合作方设置',
        hideMenu: true,
      },
    },
  ],
};

export default organizationSettings;
